import { Button, Divider, FormControl, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { useTheme } from '@mui/material/styles'

import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { isEmpty, showToast, validateEmail } from '../../../utils/AppHelper'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'
import { logoutUser } from '../../../actions/loginActions'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import serverData from '../../../api/ServerData'
import AppButton from '../../../commonComponents/AppButton'

import Rating from '@mui/material/Rating'

import Stack from '@mui/material/Stack'
import StarIcon from '@mui/icons-material/Star'
import CloseIcon from '@mui/icons-material/Close'
import moment from 'moment'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '30%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2
}

export default function FeedbackModal ({ data }) {
  var {
    open,
    isSendFeedback,
    applicationId,
    memberId,
    setIsFeedbackSent,
    getApplication,
    onClose
  } = data

  const theme = useTheme()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [ratings, setRatings] = useState(2)
  const [remark, setReview] = useState('')
  const [loading, setLoading] = useState(false)
  const [employeeFeedback, setEmployeeFeedback] = useState([])

  useEffect(() => {
    if (!isSendFeedback) {
      var body = { memberId: memberId }
      serverData.getEmployeeFeedback(
        body,
        result => {
          if (result.status) {
            setEmployeeFeedback(result.response)
          } else {
            showToast(result.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          if (error.status === 401) {
            dispatch(logoutUser(navigate)) // eslint-disable-next-line
          }
        }
      )
    }
  }, [])

  const [formError, setFormError] = useState({})

  const validateForm = () => {
    const error = {}

    if (isEmpty(remark)) {
      error.remark = 'Please provide the remark.'
    }

    setFormError(error)
    return Object.keys(error).length === 0
  }

  const handleSubmit = async () => {
    if (validateForm()) {
      setLoading(true)

      var body = {
        applicationId: applicationId,
        rating: ratings,
        remark: remark
      }

      await serverData.submitEmployeeFeedback(
        body,
        result => {
          if (result.status) {
            showToast(result.message, false)
            setIsFeedbackSent(true)
            getApplication()
          } else {
            showToast(result.message)
          }
          onClose()
          setLoading(false)
        },
        error => {
          setLoading(false)
          if (error.status === 401) {
            dispatch(logoutUser(navigate)) // eslint-disable-next-line
          }
        }
      )
    }
  }

  const getAverageRatings = employeeFeedback => {
    if (!employeeFeedback.length) return 0 // Handle case for empty array

    const totalRating = employeeFeedback.reduce(
      (sum, feedback) => sum + feedback.rating,
      0
    )
    const averageRating = totalRating / employeeFeedback.length

    return parseFloat(averageRating).toFixed(1)
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <CloseIcon
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 4,
            top: 4,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            borderRadius: 20,
            fontSize: '24px',
            cursor: 'pointer'
          }}
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextBold style={{ fontSize: '24px' }}>
              Feedback to employee
            </TextBold>
          </Grid>
          {isSendFeedback ? (
            <>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Rating
                    name='half-rating'
                    precision={0.5}
                    defaultValue={ratings}
                    onChange={(event, newValue) => setRatings(newValue)}
                    size='large'
                  />
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  maxHeight: '50vh',
                  overflowY: 'auto',
                  marginTop: '16px'
                }}
              >
                <FormControl fullWidth error={formError.remark}>
                  <TextRegular
                    style={{
                      marginBottom: '6px',
                      color: theme.palette.text.secondary
                    }}
                  >
                    What is the main reason for your ratings? *
                  </TextRegular>
                  <TextField
                    multiline
                    required
                    maxRows={4}
                    fullWidth
                    value={remark}
                    onChange={e => {
                      var { value } = e.target
                      if (value.length < 200) {
                        setReview(e.target.value)
                      }
                    }}
                    error={formError.remark}
                    helperText={formError.remark}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <AppButton
                  variant='contained'
                  onClick={() => handleSubmit()}
                  name='Submit'
                  disabled={false}
                  loading={loading}
                  style={{
                    textTransform: 'none',
                    width: 'fit-content',
                    padding: '12px 27px',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: 400,
                    marginRight: '16px'
                  }}
                />
              </Grid>
            </>
          ) : (
            <>
              {employeeFeedback.length === 0 ? (
                <>
                  <Grid item xs={12}>
                    <TextRegular>
                      No feedback is currently available for this employee.
                    </TextRegular>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={12}>
                    <Stack
                      spacing={1}
                      style={{ display: 'flex', flexDirection: 'row' }}
                    >
                      <Rating
                        name='half-rating-read'
                        precision={0.5}
                        value={getAverageRatings(employeeFeedback)}
                        size='large'
                        readOnly
                      />
                      <TextRegular style={{ marginLeft: '16px' }}>
                        {getAverageRatings(employeeFeedback)} out of 5
                      </TextRegular>
                    </Stack>

                    <TextRegular style={{ paddingTop: '16px' }}>
                      {employeeFeedback.length} ratings
                    </TextRegular>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    style={{
                      maxHeight: '50vh',
                      overflowY: 'auto',
                      marginTop: '16px'
                    }}
                  >
                    {employeeFeedback.map((data, index) => (
                      <Grid key={index} container spacing={1}>
                        <Grid item xs={12}>
                          <TextBold>{data.remark}</TextBold>
                        </Grid>
                        <Grid item xs={12}>
                          <TextRegular style={{ fontStyle: 'italic' }}>
                            By {data.companyName} on{' '}
                            {moment(data.createdAt).fromNow()}
                          </TextRegular>
                          <Rating
                            name='size-small'
                            value={data.rating}
                            size='small'
                            readOnly
                          />
                        </Grid>

                        <Grid item xs={12}>
                          {index !== employeeFeedback.length - 1 && (
                            <Divider
                              style={{ width: '100%', margin: '8px 0px' }}
                            />
                          )}
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </>
              )}
            </>
          )}
        </Grid>
      </Box>
    </Modal>
  )
}
